import { MessageCircle, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { waGeneral } from "@/config/siteConfig";
import { useQuote } from "@/context/QuoteContext";
import { trackEvent } from "@/lib/analytics";

const PageHero = ({ image, overline, title, subtitle, children }) => {
  const { openQuote } = useQuote();
  return (
    <section className="relative" data-testid="page-hero">
      <div className="absolute inset-0">
        <img src={image} alt={title} className="h-full w-full object-cover" loading="eager" />
        <div className="absolute inset-0 bg-black/45" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        {overline && <p className="text-xs font-mono uppercase tracking-[0.2em] font-semibold text-[#D99B26] mb-4">{overline}</p>}
        <h1 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-white max-w-3xl text-balance leading-[1.1]">{title}</h1>
        {subtitle && <p className="mt-4 max-w-2xl text-base sm:text-lg text-white/85 leading-relaxed">{subtitle}</p>}
        <div className="mt-8 flex flex-wrap gap-3">
          <Button onClick={() => openQuote()} data-testid="page-hero-quote-button"
            className="bg-[#D99B26] text-[#0F2F24] hover:bg-[#c98f22] font-semibold rounded-full px-6 h-11">
            <FileText className="mr-2 h-4 w-4" /> Get a Free Quote
          </Button>
          <Button asChild variant="outline" className="rounded-full px-6 h-11 border-white/70 bg-white/10 text-white hover:bg-white/20 backdrop-blur-sm">
            <a href={waGeneral()} target="_blank" rel="noopener noreferrer" data-testid="page-hero-whatsapp-button"
              onClick={() => trackEvent("whatsapp_click", { location: "page_hero" })}>
              <MessageCircle className="mr-2 h-4 w-4" /> WhatsApp Us
            </a>
          </Button>
        </div>
        {children}
      </div>
    </section>
  );
};

export default PageHero;
